class Helpers {
    static formatMoney (cents, format = '£{{amount}}') {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '')
        }
        let value = ''
        let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/

        switch (format.match(placeholderRegex)[1]) {
        case 'amount':
            value = Helpers.formatWithDelimiters(cents, 2)
            break
        case 'amount_no_decimals':
            value = Helpers.formatWithDelimiters(cents, 0)
            break
        case 'amount_with_comma_separator':
            value = Helpers.formatWithDelimiters(cents, 2, '.', ',')
            break
        case 'amount_no_decimals_with_comma_separator':
            value = Helpers.formatWithDelimiters(cents, 0, '.', ',')
            break
        }

        return format.replace(placeholderRegex, value).replace('.00', '')
    }

    static defaultOption (opt, def) {
        return (typeof opt === 'undefined' ? def : opt)
    }

    static formatWithDelimiters (number, precision, thousands, decimal) {
        precision = Helpers.defaultOption(precision, 2)
        thousands = Helpers.defaultOption(thousands, ',')
        decimal = Helpers.defaultOption(decimal, '.')

        if (isNaN(number) || number == null) {
            return 0
        }

        number = (number / 100.0).toFixed(precision)

        let parts = number.split('.')
        let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
        let cents = parts[1] ? (decimal + parts[1]) : ''

        return dollars + cents
    }

    static camelize (str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, (letter, index) => {
            return index === 0 ? letter.toLowerCase() : letter.toUpperCase()
        }).replace(/\s+/g, '')
    }

    static getParent (elem, selector) {
        return elem.matches(selector) ? elem : (elem.parentElement ? Helpers.getParent(elem.parentElement, selector) : false)
    }

    static hasParent (elem, selector) {
        return elem.matches(selector) ? true : (elem.parentElement ? Helpers.hasParent(elem.parentElement, selector) : false)
    }

    static hasParentElem (elem, parentOfElem) {
        return elem === parentOfElem ? true : (elem.parentElement ? Helpers.hasParentElem(elem.parentElement, parentOfElem) : false)
    }
}

export default Helpers



// WEBPACK FOOTER //
// ./src/resources/scripts/helpers/Helpers.js